/**
 * 3D Configurator — Entry Point
 *
 * Dual-purpose:
 *   1. Auto-initialises when Webpack bundles this as a standalone page
 *      (looks for #configurator-root in the host HTML).
 *   2. Exports ConfiguratorApp for programmatic embedding:
 *
 *        import { ConfiguratorApp } from './dist/configurator.bundle';
 *        const app = new ConfiguratorApp(myElement);
 */

import './styles/main.css';
import { ConfiguratorApp } from './app';

// ── Auto-init ──────────────────────────────────────────────────────────────

const rootEl = document.getElementById('configurator-root');
if (rootEl) {
  new ConfiguratorApp(rootEl);
}

// ── Named export (programmatic usage) ─────────────────────────────────────

export { ConfiguratorApp };
export default ConfiguratorApp;
